// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__z67I4","title":"styles_title__2D6_5"};